import TextField from "@mui/material/TextField";
import { TextFieldProps } from "@mui/material";
import { INPUT_VARIANTS, SIZES, TEXT_ALIGN } from "../utils/enums";

const GenericInput = ({
  type,
  value,
  onChange,
  label = "",
  className = "",
  placeholder = "",
  variant = INPUT_VARIANTS.outlined,
  disabled = false,
  textAlign = TEXT_ALIGN.left,
  size = SIZES.sm,
  slotProps = {},
  sx = {},
}: {
  type: string;
  value?: string;
  label?: string;
  variant?: INPUT_VARIANTS;
  disabled?: boolean;
  className?: string;
  placeholder?: string;
  size?: SIZES;
  textAlign?: TEXT_ALIGN;
  slotProps?: TextFieldProps["slotProps"];
  sx?: TextFieldProps["sx"];
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}) => {
  return (
    <TextField
      label={label}
      className={className}
      variant={variant}
      type={type}
      size={size}
      placeholder={placeholder}
      value={value}
      disabled={disabled}
      onChange={onChange}
      sx={{
        ...sx,
        "& .MuiOutlinedInput-root": {
          "&.Mui-focused fieldset": {
            borderColor: "var(--color-neutral-dark)",
          },
        },
      }}
      slotProps={slotProps}
      InputProps={{
        inputProps: { style: { textAlign } },
      }}
    />
  );
};
export default GenericInput;
